<template>
  <div>
    <v-container v-if='!group'>loading... please wait</v-container>
    <wc-page-title v-else :title="group.description">
      <template v-slot:rightSide>
        <v-btn class='mr-2' depressed height='35px' width='80px' :color="showInactive ? 'grey' : ''"
          @click='showInactive = !showInactive'>
          <div class='mt-n1'>
            <v-icon class='mr-2' small>{{ showInactive ? 'mdi-close' : 'mdi-check' }}</v-icon>
            <span class='mb-n1' style='font-size: 10px; letter-spacing: 0.8px;'>{{ showInactive ? 'Hide' : 'Show'
              }}</span>
            <div style='font-size: 10px; letter-spacing: 0.8px;'>Inactive</div>
          </div>
        </v-btn>
        <v-btn class='mr-2' depressed height='35px' width='80px' :color="showVisited ? 'success' : ''"
          @click='showVisited = !showVisited'>
          <div class='mt-n1'>
            <v-icon class='mr-2' small>{{ showVisited ? 'mdi-close' : 'mdi-check' }}</v-icon>
            <span class='mb-n1' style='font-size: 10px; letter-spacing: 0.8px;'>{{ showVisited ? 'Hide' : 'Show'
              }}</span>
            <div style='font-size: 10px; letter-spacing: 0.8px;'>Visited</div>
          </div>
        </v-btn>
        <v-btn depressed height='35px' width='80px' :color="reverseRoute ? 'primary' : ''"
          @click='reverseRoute = !reverseRoute'>
          <div class='mt-n1'>
            <span class='mb-n1' style='font-size: 10px; letter-spacing: 0.8px;'>{{ reverseRoute ? 'Reset' : 'Reverse'
              }}</span>
            <div style='font-size: 10px; letter-spacing: 0.8px;'>{{ reverseRoute ? 'Order' : 'Route' }}</div>
          </div>
        </v-btn>
      </template>
    </wc-page-title>

    <!-- PROGRESS BAR -->
    <div v-if='group' style='padding: 10px 16px 14px; background: #f5f5f5;'>
      <div style='position: relative; padding-top: 34px;'>
        <!-- Floating badge -->
        <div :style='{ left: badgeLeft }' style='position: absolute; top: 0; transform: translateX(-50%);'>
          <div :style='allComplete ? "background:#2E7D32" : "background:#0D1B2A"'
            style='color:#fff; border-radius:20px; padding:3px 11px; font-size:13px; font-weight:700; white-space:nowrap; position:relative; display:inline-block;'>
            {{ completedCount }}/{{ totalCount }}
            <div :style='allComplete ? "border-top-color:#2E7D32" : "border-top-color:#0D1B2A"'
              style='position:absolute; bottom:-6px; left:50%; transform:translateX(-50%); width:0; height:0; border-left:6px solid transparent; border-right:6px solid transparent; border-top:6px solid;'></div>
          </div>
        </div>
        <!-- Track -->
        <div style='height:36px; border-radius:100px; background:#DDEEFF; display:flex; overflow:hidden;'>
          <!-- Completed fill -->
          <div :style='{ width: progressPercent + "%", background: allComplete ? "#4CAF50" : "#1976D2", transition: "width 0.5s ease, background 0.3s" }'
            style='height:100%; border-radius:100px 0 0 100px; display:flex; align-items:center; justify-content:flex-end; padding-right:8px; min-width:0;'>
            <v-icon v-if='completedCount > 0' small color='white'>mdi-check</v-icon>
          </div>
          <!-- Remaining -->
          <div style='flex:1; display:flex; align-items:center; padding-left:12px;'>
            <span :style='allComplete ? "color:#2E7D32; font-weight:600;" : "color:#1565C0; font-weight:500;"'
              style='font-size:12px; letter-spacing:0.3px;'>
              {{ motivationalText }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <v-container class='pt-0'>

      <!--       <v-row v-if='anyQuickpaysNotComplete'>
        <v-col cols='12' md='4' class='text-center'>
          <v-icon color='red' left>mdi-timer-outline</v-icon>
          <span class='font-weight-bold'>
            Quickpay Customer<br>
            must be done by 9:00am
          </span><br>
        </v-col>
      </v-row> -->

      <v-row>
        <v-col cols='12' md='4'>
          <wc-loading line v-if='isLoading'></wc-loading>
          <div v-if='reverseRoute' class='primary--text mb-2 font-weight-bold body-2'>Route order is reversed</div>
          <div v-if='allComplete' class='mb-2 font-weight-bold body-2'>Looks like you're all finished!</div>
          <template v-if='group && !!group.unrouted.length'>
            <v-row class='mt-n6'>
              <v-col cols='12'>
                <span class='headline error--text text-uppercase font-weight-light'>
                  Un-routed Projects
                </span>
                <v-divider></v-divider>
                <span class='caption error--text font-weight-light'>
                  (Not in correct order - please talk to office)
                </span>
              </v-col>
            </v-row>
            <project-card v-for='project in filteredUnrouted' :key='project.id' :project='project' class='mb-6'
              @update='update'></project-card>
            <v-row class='mt-n6'>
              <v-col cols='12'>
                <span class='headline error--text text-uppercase font-weight-light'>
                  Routed Projects
                </span>
                <v-divider></v-divider>
              </v-col>
            </v-row>
          </template>
          <template v-if='group'>
            <project-card v-for='project in filteredProjects' :key='project.id' :project='project' class='mb-6'
              @update='update'></project-card>
          </template>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import miscServices from '@/services/misc'
import projectsAPI from '@/modules/projects/api/projects'
import ProjectCard from './ProjectCard'
import { isProjectActive } from '@/modules/projects/services/activeProjects'
import _ from 'lodash'

export default {
  name: 'project-route',
  data: () => ({
    isLoading: false,
    showVisited: false,
    showInactive: true,
    reverseRoute: false,
    group: null,
    tab: null
  }),
  computed: {
    isLawnDivision() {
      let lawnDiv = _.find(this.$store.state.misc.divisions, d => d.division === 'Lawn')
      return this.group.division == lawnDiv.id
    },
    filteredProjects() {
      if (this.group) {
        let projects = this.isLawnDivision ? _.filter(this.group.projects, 'has_lawn_care') : this.group.projects
        if (this.reverseRoute) {
          projects = _.orderBy(projects, 'route_number', 'desc')
        }
        if (this.showVisited && this.showInactive) {
          return projects
        } else if (this.showVisited && !this.showInactive) {
          return _.filter(projects, w => { return w.crew_visit_status || !w.status })
        } else if (!this.showVisited && this.showInactive) {
          return _.filter(projects, w => { return !w.crew_visit_status || w.status })
        } else {
          return _.filter(projects, w => !w.status && !w.crew_visit_status)
        }
      }
      return []
    },
    filteredUnrouted() {
      if (this.group) {
        let unrouted = this.isLawnDivision ? _.filter(this.group.unrouted, 'has_lawn_care') : this.group.unrouted
        if (this.showVisited && this.showInactive) {
          return unrouted
        } else if (this.showVisited && !this.showInactive) {
          return _.filter(unrouted, w => { return w.crew_visit_status || !w.status })
        } else if (!this.showVisited && this.showInactive) {
          return _.filter(unrouted, w => { return !w.crew_visit_status || w.status })
        } else {
          return _.filter(unrouted, w => !w.status && !w.crew_visit_status)
        }
      }
      return []
    },
    allComplete() {
      if (this.group) {
        return _.every(this.filteredProjects, w => w.status || w.crew_visit_status === 'Completed' || w.crew_visit_status === 'Attempted') && _.every(this.filteredUnrouted, w => w.status || w.crew_visit_status === 'Completed' || w.crew_visit_status === 'Attempted')
      }
      return false
    },
    activeProjects() {
      if (!this.group) return [];
      return [...(this.group.projects || []), ...(this.group.unrouted || [])].filter(p => isProjectActive(p));
    },
    completedCount() {
      return this.activeProjects.filter(p => p.crew_visit_status === 'Completed').length;
    },
    totalCount() {
      return this.activeProjects.length;
    },
    progressPercent() {
      if (!this.totalCount) return 0;
      return Math.round((this.completedCount / this.totalCount) * 100);
    },
    badgeLeft() {
      const clamped = Math.min(Math.max(this.progressPercent, 6), 94);
      return clamped + '%';
    },
    motivationalText() {
      const p = this.progressPercent;
      if (p >= 100) return 'Route complete';
      if (p >= 75)  return 'Final push';
      if (p >= 50)  return 'Halfway there! Crushing it';
      if (p >= 25)  return 'Great work—keep it up';
      return 'Just getting rolling';
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.group = await projectsAPI.getProjectRouteGroup(this.$route.params.id);
      this.isLoading = false;
    },
    update(project) {
      if (project.route_number) {
        miscServices.replaceObject(this.group.projects, project)
      } else {
        miscServices.replaceObject(this.group.unrouted, project)
      }
    }
  },
  components: {
    'project-card': ProjectCard
  }
}
</script>
